import { render } from "./AddCompteEntrepriseModal.vue?vue&type=template&id=10b724ec&ts=true"
import script from "./AddCompteEntrepriseModal.vue?vue&type=script&lang=ts"
export * from "./AddCompteEntrepriseModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__